import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Row } from "antd";
import moment from "moment";

import partnersApi from "../../../apis/Partners.api";
import GroupBuyingEvent from "../../../pages/channel/GroupBuyingEvent";
import { isEndWithConsonant } from "../../../utils/status";
import { toastAlert } from "../../AlertComponent";

const EventComponent = ({ setAlertShow }) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const [eventShow, setEventShow] = useState(false);

	useEffect(() => {
		getTime();
	}, []);

	const getTime = async () => {
		const res = await partnersApi.getServerTime();
		if (res.code === 200) {
			const endDate = moment("2023-06-28 17:00");
			// const endDate = moment("2023-06-27 11:12");
			const serverTime = moment(res.result);
			// console.log(moment(res.result).format("YYYY.MM.DD a h:mm:ss"));
			if (endDate.diff(serverTime) > 0) {
				setEventShow(true);
			} else {
				setEventShow(false);
			}
		} else {
			setEventShow(false);
		}
	};

	const eventUserAlert = async () => {
		if (cUser?.id) {
			const param = {
				cooperate_id: null,
				influencer_id: reduxChannel?.user_id,
				name: cUser?.name ?? "",
				phone: cUser.phone,
			};
			const res = await partnersApi.createGroupBuyingAlert(param);
			if (res.code === 200) {
				toastAlert("정상적으로 등록되었습니다!");
			} else {
				toastAlert("이미 등록된 번호입니다.");
			}
		} else {
			if (reduxChannel?.user_id === 9) {
				history.push(`/together/channel/login?id=squidtv`);
			} else {
				setAlertShow(true);
			}
		}
	};

	return (
		<div className={`home-each`}>
			<div className={`max-width-apply home-group-buying`}>
				<div className={`home-recommend-vertical`}>
					<div className={`home-recommend-horizontal`}>
						<div className={`recommend-title`}>
							<p className={`type-kr`}>
								{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
									? "갑오징어들을 위한 이벤트!"
									: "공동구매"}
							</p>
							{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9 ? (
								<p className={`title`} style={{ whiteSpace: "normal" }}>
									{reduxChannel?.name}
									{isEndWithConsonant(reduxChannel?.name) ? "이" : "가"} 준비한
									{"\n"}
									이벤트
								</p>
							) : (
								<p className={`title`}>
									{reduxChannel?.name}
									{isEndWithConsonant(reduxChannel?.name) ? "과" : "와"}{" "}
									함께하는{"\n"}공동구매
								</p>
							)}
						</div>
						<Row style={{ gap: "1em" }}>
							<Button
								className={`home-group-buying-btn black`}
								onClick={eventUserAlert}
							>
								{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
									? "이벤트"
									: "공동구매"}{" "}
								소식받기
							</Button>
						</Row>
					</div>

					<div
						className={`home-recommend-horizontal`}
						style={{
							width: "100%",
						}}
					>
						{eventShow ? (
							<GroupBuyingEvent />
						) : (
							<div className={`group-buying-product-body done-group-buying`}>
								<img
									src={`/assets/images/channel/timer.png`}
									alt={`공동구매`}
									className={`group-buying-alert-icon`}
									style={{
										height: "auto",
										width: "1.6em",
									}}
								/>
								<p>
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "이벤트"
										: "공동구매"}
									가 성황리에 마무리 되었습니다.{"\n"}다음{" "}
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "이벤트"
										: "공동구매"}{" "}
									소식도 놓치지 않도록 소식 받아보세요!
								</p>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
export default EventComponent;
